import TransactionHistoryStoreProvider from './TransactionHistoryStoreProvider.js';

export default TransactionHistoryStoreProvider;
